import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PrimaryButton from './PrimaryButton';
import { globalStyles } from './style/gstheme';
import { Typography } from '@material-ui/core';

const styles = () => {
  return Object.assign({
    legalPaper: {
      margin: 4
    }
  }, globalStyles);
};

class PartnerLegal extends React.Component {

  render() {

    const { classes, title, text } = this.props;

    return (
      <Dialog
        classes={{
          paper: classes.legalPaper
        }}
        open={this.props.open}
        data-test="partner-legal"
        aria-labelledby="legal-dialog-title" >
        <DialogTitle data-test="ts-and-cs-content" disableTypography className={classes.mainHeading} style={{ textAlign: 'center' }} id="legal-dialog-title">{title}</DialogTitle>
        <DialogContent>
          {text.map((p, index) => <Typography paragraph variant="body2" key={index}>{p}</Typography>)}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <PrimaryButton dataTest="close-legal" onClick={this.props.exitLegal}>Close</PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  }
}

PartnerLegal.defaultProps = {
  title: "Terms of Use"
};

PartnerLegal.propTypes = {
  title: PropTypes.string,
  text: PropTypes.array,
  open: PropTypes.bool.isRequired,
  exitLegal: PropTypes.func.isRequired,
  classes: PropTypes.object
};

export default withStyles(styles)(PartnerLegal);